export default __webpack_public_path__ + "static/media/home-restaurant-img-23.62d81671.jpg";